import { createRouter, createWebHistory } from 'vue-router'

const routes = 
[
  { path: '/', name: 'homeloans', component: () => import('../views/AccountList.vue'),
      meta: { title: 'Home Loan App - Built for Mortgage Brokers', 
        metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 
  //{ path: '/', name: 'home', component: () => import('../views/HomeView.vue'),
  //    meta: { title: 'Home Loan App - Built for Mortgage Brokers', 
  //      metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

 // { path: '/opportunity/:id', name: 'opportunity', component: () => import('../views/OpportunityView.vue'), props: true,
  //      meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
 //         metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},       

  { path: '/login', name: 'login', component: () => import('../views/LoginView.vue'),
        meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
          metaTags: { desc: 'The home page of our example app.' } }}, 

  //{ path: '/living-expenses/:id', name: 'expenses', component: () => import('../views/ExpensesView.vue'), props: true,
  //        meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
  //          metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  //{ path: '/fact-find/:id', name: 'factfind', component: () => import('../views/FactfindView.vue'), props: true,
  //      meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
  //        metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},           
            
  { path: '/upload', name: 'upload', component: () => import('../views/UploadView.vue'),
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
          metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  { path: '/portfolio', name: 'portfolio', component: () => import('../views/PortfolioAccount.vue'),
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
          metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},   

  { path: '/portfolioReport/', name: 'portfolioReport', component: () => import('../views/PortfolioReport.vue'), 
      meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
      metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  { path: '/portfolioLender/', name: 'portfolioLender', component: () => import('../views/PortfolioLender.vue'), 
        meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
        metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  { path: '/tasks', name: 'tasks', component: () => import('../views/TaskView.vue'),
    meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
    metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},
      
  { path: '/monthlyReport/:page/:type', name: 'monthlyReport', component: () => import('../views/ReportMonthly.vue'), props: true,
    meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
      metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  { path: '/homeloans', name: 'accountList', component: () => import('../views/AccountList.vue'),
        meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
        metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},  
 
  { path: '/homeloans/:id', name: 'account', component: () => import('../views/AccountView.vue'), props: true,   
        meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
        metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  { path: '/customers', name: 'borrowerList', component: () => import('../views/BorrowerList.vue'),
        meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
        metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},  

  { path: '/customers/:id', name: 'borrower', component: () => import('../views/BorrowerView.vue'), props: true,
            meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
              metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  { path: '/settings', name: 'settings', component: () => import('../views/SettingsView.vue'),
    meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
      metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},            

 // { path: '/compare', name: 'compare', component: () => import('../views/ProductCompareView.vue'),   
 //       meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
 //         metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

 // { path: '/blog', name: 'blogList', component: () => import('../views/BlogList.vue'),   
  //        meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
 //           metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

 // { path: '/blog/:id', name: 'blog', component: () => import('../views/BlogView.vue'),  props: true,  
 //           meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
 //             metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},           

  { path: '/calculators', name: 'calculators', component: () => import('../views/CalculatorView.vue'),   
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
            metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 
            
  { path: '/calculators/repayment-calc', name: 'loanRepayment', component: () => import('../views/calculators/loanRepayment.vue'),
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
             metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 
               
  { path: '/calculators/stampduty', name: 'stampDuty', component: () => import('../views/calculators/stampDuty.vue'),
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
            metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 

  { path: '/calculators/lmi-quote', name: 'lmiQuote', component: () => import('../views/calculators/lmiQuote.vue'),
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
            metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }}, 
              
  { path: '/calculators/payslip-calc', name: 'incomeCalc', component: () => import('../views/calculators/incomeCalc.vue'),
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
            metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},   
            
  { path: '/calculators/ytd-calc', name: 'ytdCalc', component: () => import('../views/calculators/ytdCalc.vue'),
          meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
            metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},

  { path: '/calculators/refinance-calc', name: 'refinanceCalc', component: () => import('../views/calculators/refinanceCalc.vue'),
            meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
              metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},

  { path: '/rate-roll', name: 'rateRoll', component: () => import('../views/RateRollView.vue'),
            meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
              metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},





  { path: '/lender/:name', name: 'lender', component: () => import('../views/LendersView.vue'), props: true,
            meta: { title: 'Home Loan App - Your local home loan mortgage brokers', 
              metaTags: { desc: 'The home page of our example app.' }, requiresAuth: true }},





  //Catchall 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
            meta: { title: 'Home Loan App - 404', 
              metaTags: { desc: 'We can`t find this page?' }}
  }
]

  const router = createRouter(
    {
      history: createWebHistory(process.env.BASE_URL),
      routes,
      scrollBehavior() 
        { window.scroll({top:0,left:0,behavior:'smooth'}) }
    })


  //Add Meta Tags
  router.beforeEach((to, from) => 
  { 
    document.title = to.meta?.title ?? 'Home Loan App - Built for Mortgage Brokers'
    const tag = document.createElement('meta')
    tag.setAttribute('description', to.meta.metaTags.desc)  
    document.getElementsByTagName('head')[0].appendChild(tag)
  })


export default router